export default {

    frontstage: {

    },
    backstage: {
        DASHBOARD: 'dashboard',
        INTEGREATED_SERACH: 'integrated-search',
        DIGITAL_RESOURCE_MANAGEMENT: 'digital-resource-management',
        REVIEW_MANAGEMENT: 'review-management',
        FRONT_STAGE_DATA_PUBLISH: 'review-management/front-stage-data-publish',
        RECORDGROUP_MANAGEMENT: 'file-type-management/recordgroup',
        SUB_RECORDGROUP_MANAGEMENT: 'file-type-management/sub_recordgroup',
        FOLDER_MANAGEMENT: 'file-type-management/folder',
        ORGANIZATION: 'file-type-management',
        ACCOUNT_MANAGEMENT: 'system-management/account-management',
        SYSTEM_LOG: 'system-management/system-log',
        ISSUE_REPORT_MANAGEMENT: 'system-management/issue-report',
        SYNONYM_MANAGEMENT: 'system-management/synonym-management',
        MY_ISSUE_REPORT: 'my-issue-report',
        FRONT_STAGE_MANAGEMENT: 'front-stage-management',
        THEME_MANAGEMENT: 'front-stage-management/theme-management',
        LATEST_NEWS_MANAGEMENT: 'front-stage-management/latest-news-management',
        RECOMMENDED_ARTICLE_MANAGEMENT: 'front-stage-management/recommended-article-management',
        FREQUENTLY_ASKED_QUESTION_MANAGEMENT: 'front-stage-management/frequently-asked-question-management',
    }
}